import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import VolumeSVG from "../../../public/icons/volume.svg";
import MuteSVG from "../../../public/icons/mute.svg";
import StartSVG from "../../../public/icons/start.svg";
import classes from "./HeaderVideoPlayer.module.scss";
import { useTranslation } from "next-i18next";
import TranslatedLink from "components/utilities/TranslatedLink";
import classNames from "classnames";

const HeaderVideoPlayer = () => {
  const { t } = useTranslation("career");
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isVideoMuted, setIsVideoMuted] = useState(true);

  const videoOnClickHandler = () => {
    const videoElement = videoRef.current;
    if (!videoElement) return null;

    if (videoElement.paused) {
      videoElement.play();
    } else {
      videoElement.pause();
    }
  };

  const toggleSoundHandler = (event: any) => {
    event.stopPropagation();
    const videoElement = videoRef.current;
    if (!videoElement) return null;

    videoElement.muted = !videoElement.muted;
    setIsVideoMuted(videoElement.muted);
  };

  const restartVideo = () => {
    const videoElement = videoRef.current;
    if (!videoElement) return null;

    videoElement.currentTime = 0;
  };

  return (
    <div className="position-relative d-block">
      <video
        onClick={videoOnClickHandler}
        ref={videoRef}
        className={classes.headerVideoPlayer__video}
        autoPlay={true}
        muted
        loop
      >
        <source src="/videos/reference.mp4" type="video/mp4" />
      </video>
      <div className={classes.headerVideoPlayer__videoControlLeft}>
        <TranslatedLink href="/career#showMoreButton">
          <Button
            id="showMoreButton"
            size="sm"
            className={classNames("me-3", classes.headerVideoPlayer__showMore)}
            variant="primary"
            aria-label={t("video.show_more")}
          >
            <p className="m-0 fs-5">{t("video.show_more")}</p>
          </Button>
        </TranslatedLink>
      </div>
      <div className={classes.headerVideoPlayer__videoControl}>
        <Button
          onClick={restartVideo}
          size="sm"
          className="me-3"
          variant="outline-primary"
          aria-label={t("video.restart")}
        >
          <StartSVG />
        </Button>
        <Button
          onClick={toggleSoundHandler}
          size="sm"
          variant="outline-primary"
          aria-label={t("video.mute")}
        >
          {isVideoMuted ? <MuteSVG /> : <VolumeSVG />}
        </Button>
      </div>
    </div>
  );
};

export default HeaderVideoPlayer;
